import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const BanerSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  return (
    <div className="relative">
      <div className="bg_image_Service relative min-h-[60vh] lg:min-h-[70vh] flex items-center justify-center bg-cover bg-center bg-no-repeat">

        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-40"></div>

        {/* Content */}
        <div className="relative z-10 containers mx-auto px-4 sm:px-6 lg:px-8 text-center">

          {/* Breadcrumb */}
          <nav
            className="mb-6 text-sm md:text-base"
            data-aos="fade-down"
          >
            {/* <div className="flex items-center justify-center space-x-2 text-gray-300">
              <span className="hover:text-white transition-colors cursor-pointer">Tecz</span>
              <span>-</span>
              <span className="hover:text-white transition-colors cursor-pointer">
                IT Solutions & Technology wordpress theme
              </span>
              <span className="text-blue-400">{">"}</span>
              <span className="text-white font-semibold">Service</span>
            </div> */}
          </nav>

          {/* Heading */}
          <h1
            className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-6 tracking-tight"
            data-aos="zoom-in"
          >
            Service
          </h1>

          {/* Accent */}
          <div className="flex justify-center mb-8" data-aos="fade-up">
            <div className="w-20 h-1 bg-gradient-to-r from-blue-400 to-blue-600 rounded-full"></div>
          </div>

          {/* Subtitle */}
          <p
            className="text-gray-200 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed"
            data-aos="fade-up"
            data-aos-delay="200"
          >

            Delivering innovative IT solutions and cutting-edge technology services
            to empower your business growth and digital transformation

          </p>

          {/* CTA Buttons */}
          <div
            className="flex flex-col sm:flex-row gap-4 justify-center items-center mt-10"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <button className=" bg-[#1C74BB] text-white py-[14px] px-[18px] rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg">
              Our Services
            </button>
            <button className="flex items-center gap-2 border-2 border-white text-white hover:bg-white hover:text-gray-900 py-[10px] px-[18px] rounded-lg font-semibold transition-all duration-300">
              Get Quote <span className="text-lg">➜</span>
            </button>
          </div>
        </div>

     
      </div>
    </div>
  );
};

export default BanerSection;
